export const CURRENCY_KEY = 'currency';

export enum PAYMENT_GATEWAYS_ENUM {
  TROPIPAY = 'tropipay',
  STRIPE = 'stripe',
  PAYPAL = 'paypal',
  ELAVON = 'elavon',
  BILL_POCKET = 'bill-pocket',
  REDSYS = 'redsys',
  DUCAPP = 'ducapp',
  MERCADO_PAGO = 'mercado-pago',
  MONEI = 'monei',
  LABERINTO = 'laberinto',
  BIZUM = 'bizum',
  PAGUELO_FACIL = 'paguelofacil',
  PAY_NO_PAIN = 'paynopain',
  BIDAIONDO = 'bidaiondo',
  AUTHORIZE = 'authorize-net',
  PAGOS_CARIBE_CARD = 'pagos-caribe-card',
}

export enum PAYMENT_METHOD_ENUM {
  CREDIT_CARD = 'CREDIT_CARD',
  BIZUM = 'BIZUM',
  TRANSFER = 'TRANSFER',
  PAYPAL = 'PAYPAL',
  TROPIPAY = 'TROPIPAY',
  TROPIPAY_BALANCE = 'TROPIPAY_BALANCE',
  BANK_TRANSFER = 'BANK_TRANSFER',
  INTERNAL_WALLET = 'INTERNAL_WALLET',
  CASH_ON_PICK_UP = 'CASH_ON_PICK_UP',
  PAGOS_CARIBE = 'PAGOS_CARIBE',
}
